<app-passes-student [effectiveUser]="effectiveUser" *ngIf="isStudent"></app-passes-student>

<app-passes-teacher-v2 [effectiveUser]="effectiveUser" *ngIf="isStaff"></app-passes-teacher-v2>
